module.exports = __webpack_public_path__ + "static/media/maintenance-history.9d06a260.svg";